import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" {...props}><path fillRule="evenodd" d="M12.97 27.53a.75.75 0 01-.073-.976l.073-.084 8.467-8.468-8.467-8.469a.75.75 0 01-.073-.976l.073-.085a.75.75 0 01.976-.072l.084.073 8.998 8.998a.75.75 0 01.072.977l-.072.084-8.998 8.998a.749.749 0 01-1.06 0z" /></svg>);